import { render } from "./ListarPreguntas.vue?vue&type=template&id=b36c9dbc"
import script from "./ListarPreguntas.vue?vue&type=script&lang=js"
export * from "./ListarPreguntas.vue?vue&type=script&lang=js"

import "./ListarPreguntas.vue?vue&type=style&index=0&id=b36c9dbc&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__